import * as t from 'io-ts'
import * as functions from 'firebase/functions'
import { FirebaseApp } from 'firebase/app'
import * as F from 'fp-ts'

function decode<T>(decoder: t.Decoder<unknown, T>, data: unknown) {
  return F.function.pipe(
    decoder.decode(data),
    F.either.getOrElseW((errors) => {
      console.log(errors)
      throw new Error('decode: failed to parse document')
    }),
  )
}

export async function getData<T>(
  firebaseApp: FirebaseApp,
  url: string,
  headers: Record<string, string>,
  decoder: t.Decoder<unknown, T>,
) {
  const getJSON = functions.httpsCallable(functions.getFunctions(firebaseApp, 'europe-west1'), 'getJSON')
  const { data } = await getJSON({ url, headers })
  return decode(decoder, data)
}
